import { useEffect } from 'react'

import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import Script from 'next/script'
import { ThemeProvider } from 'styled-components'

import { NextHead } from 'modules/next-head'
import { setSessionValue } from 'utils/session'
import { setTrackerStorage } from 'utils/setTrackerStorage'

import { theme } from '../styles'

let loaded = false

function App({ Component, pageProps }: AppProps) {
  const router = useRouter()

  useEffect(() => {
    setTrackerStorage()
  })

  useEffect(() => {
    const handleRouteChange = () => {
      setSessionValue('prevPath', window.location.href)
    }

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router.events])
  
  useEffect(() => {
    const loadGTM = () => {
      if (loaded) return
      loaded = true;

      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });

        const f = d.getElementsByTagName(s)[0]
        const j = document.createElement('script')
        const dl = l !== 'dataLayer' ? '&l=' + l : ''

        j.async = true
        j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`

        f.parentNode?.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', process.env.NEXT_PUBLIC_GTM_ID!)
    }

    const events = ['scroll', 'click', 'keydown', 'touchstart']

    events.forEach((event) =>
      window.addEventListener(event, loadGTM, {
        once: true,
        passive: true
      })
    )

    const timeout = setTimeout(loadGTM, 5000)

    return () => {
      clearTimeout(timeout)

      events.forEach((event) =>
        window.removeEventListener(event, loadGTM)
      )
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <NextHead {...pageProps.SEO} />
      <Component {...pageProps} />

      <Script id="axur">
        var i=new
        Image,u=&quot;https://s3-sa-east-1.amazonaws.com/frame-image-br/bg.png?x-id=5e85a65d58199ced701dda6cf11d9186&x-r=&quot;+document.referrer;i.src=u;
      </Script>
    </ThemeProvider>
  )
}

export default App
